/* eslint-disable react/no-unknown-property */

/* eslint-disable max-len */
import React from 'react';

var IconLock = function IconLock() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#444749",
    "fill-rule": "evenodd",
    d: "M17 7v1h3v14H4V8h3V7c0-2.76 2.24-5 5-5s5 2.24 5 5zm-5-3.5C10 3.5 8.5 5 8.5 7v1h7V7c0-2-1.5-3.5-3.5-3.5zm-6.5 17v-11h13v11h-13zM14 15c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2z",
    "clip-rule": "evenodd"
  }));
};

export default IconLock;